module.exports = __webpack_public_path__ + "static/media/lights-holiday.816af50a.svg";